/* USCT: YouTube-Klick-Fassade
 * Ersetzt eingebettete YouTube-Videos durch ein Vorschaubild mit Abspielknopf.
 * Das eigentliche Video wird erst nach einem Klick geladen.
 * Wirkung: schnellerer Seitenaufbau und keine YouTube-Verbindung ohne Zutun des Besuchers.
 * Defensiv gebaut: Bei jedem Fehler bleibt das Original-Video unangetastet.
 */
(function () {
  'use strict';

  function videoIdAus(url) {
    if (!url) return null;
    var m = url.match(/youtube(?:-nocookie)?\.com\/embed\/([A-Za-z0-9_-]{6,})/);
    return m ? m[1] : null;
  }

  function fassadeBauen(iframe) {
    var id = videoIdAus(iframe.getAttribute('src') || '');
    if (!id) return;

    var titel = iframe.getAttribute('title') || 'Video abspielen';
    var box = document.createElement('div');
    box.className = 'usct-video';
    box.setAttribute('role', 'button');
    box.setAttribute('tabindex', '0');
    box.setAttribute('aria-label', titel + ' – Video laden und abspielen');

    // Seitenverhältnis und Randradius des Originals übernehmen, damit das Layout gleich bleibt
    var stil = iframe.getAttribute('style') || '';
    var ar = stil.match(/aspect-ratio:\s*([^;]+)/);
    var br = stil.match(/border-radius:\s*([^;]+)/);
    var mb = stil.match(/margin-bottom:\s*([^;]+)/);
    box.style.aspectRatio = ar ? ar[1].trim() : '16 / 9';
    if (br) box.style.borderRadius = br[1].trim();
    if (mb) box.style.marginBottom = mb[1].trim();

    var bild = document.createElement('img');
    bild.className = 'usct-video__bild';
    bild.src = 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg';
    bild.alt = titel;
    bild.loading = 'lazy';
    bild.width = 480;
    bild.height = 360;

    var knopf = document.createElement('span');
    knopf.className = 'usct-video__knopf';
    knopf.setAttribute('aria-hidden', 'true');

    var hinweis = document.createElement('span');
    hinweis.className = 'usct-video__hinweis';
    hinweis.textContent = 'Video von YouTube laden';

    box.appendChild(bild);
    box.appendChild(knopf);
    box.appendChild(hinweis);

    function abspielen() {
      var neu = document.createElement('iframe');
      neu.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      neu.title = titel;
      neu.setAttribute('frameborder', '0');
      neu.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      neu.setAttribute('allowfullscreen', '');
      neu.style.cssText = 'width:100%;height:100%;border:0;display:block;';
      box.innerHTML = '';
      box.appendChild(neu);
      box.removeAttribute('role');
      box.removeAttribute('tabindex');
    }

    box.addEventListener('click', abspielen);
    box.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); abspielen(); }
    });

    iframe.parentNode.replaceChild(box, iframe);
  }

  function start() {
    try {
      var liste = document.querySelectorAll('iframe[src*="youtube.com/embed"], iframe[src*="youtube-nocookie.com/embed"]');
      for (var i = 0; i < liste.length; i++) {
        try { fassadeBauen(liste[i]); } catch (e) { /* dieses Video bleibt wie es war */ }
      }
    } catch (e) { /* im Zweifel nichts verändern */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
